export default __webpack_public_path__ + "static/media/5photo(new).07137519.jpg";